import { render, staticRenderFns } from "./EditClientePage.vue?vue&type=template&id=0d52342e&"
import script from "./EditClientePage.vue?vue&type=script&lang=js&"
export * from "./EditClientePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports